import { useEffect, useState } from 'react';
import { MonitoringSetupDataType } from './AlertStatusSetupContext';

const useMonitoringSetupData = (initialMonitoringSetupData: MonitoringSetupDataType) => {
  const [monitoringSetupData, setMonitoringSetupData] = useState(initialMonitoringSetupData);

  useEffect(() => {
    setMonitoringSetupData(initialMonitoringSetupData);
  }, [initialMonitoringSetupData]);

  const [isMonitoringSetupValid, setMonitoringSetupValid] = useState(true);
  const [isMonitoringSetupSubmissionTouched, setMonitoringSetupSubmissionTouched] = useState(false);
  const [isMonitoringSetupSubmitted, setMonitoringSetupSubmitted] = useState(false);

  return {
    monitoringSetupData,
    setMonitoringSetupData,
    isMonitoringSetupValid,
    setMonitoringSetupValid,
    isMonitoringSetupSubmissionTouched,
    setMonitoringSetupSubmissionTouched,
    isMonitoringSetupSubmitted,
    setMonitoringSetupSubmitted,
  };
};

export default useMonitoringSetupData;
